/**
 * demo.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2019, Codrops
 * http://www.codrops.com
 */

class mouseInit {
  constructor() {
    this.initCursor();
    this.initHovers();
  }

  initCursor() {
    const { Back } = window;
    this.outerCursor = document.querySelector(".circle-cursor--outer");
    this.innerCursor = document.querySelector(".circle-cursor--inner");
    this.innerCursorBox = this.innerCursor.getBoundingClientRect();
    this.outerCursorBox = this.outerCursor.getBoundingClientRect();
    this.outerCursorSpeed = 0;
    this.easing = Back.easeOut.config(3);
    this.clientX = -100;
    this.clientY = -100;
    this.showCursor = false;

    const unveilCursor = () => {
      TweenMax.set(this.innerCursor, {
        x: this.clientX,
        y: this.clientY
      });
      TweenMax.set(this.outerCursor, {
        x: this.clientX - this.outerCursorBox.width / 2,
        y: this.clientY - this.outerCursorBox.height / 2
      });
      setTimeout(() => {
        this.outerCursorSpeed = 0;
      }, 100);
      this.showCursor = true;
    };
    document.addEventListener("mousemove", unveilCursor);

    document.addEventListener("mousemove", e => {
      this.clientX = e.clientX;
      this.clientY = e.clientY;
    });

    const render = () => {
      TweenMax.set(this.innerCursor, {
        x: this.clientX,
        y: this.clientY
      });
      if (!this.isStuck) {
        TweenMax.to(this.outerCursor, this.outerCursorSpeed, {
          x: this.clientX - this.outerCursorBox.width / 2,
          y: this.clientY - this.outerCursorBox.height / 2
        });
      }
      if (this.showCursor) {
        document.removeEventListener("mousemove", unveilCursor);
      }
      requestAnimationFrame(render);
    };
    requestAnimationFrame(render);
  }

  initHovers() {

    /* Hover su link */
    
    const handleMouseEnter = e => {
      this.isStuck = true;
      const target = e.currentTarget;
      const box = target.getBoundingClientRect();
      
      this.outerCursorOriginals = {
        width: this.outerCursorBox.width,
        height: this.outerCursorBox.height
      };

      TweenMax.to(this.outerCursor, 0.6, {
        // x: box.left,
        // y: box.top,
        // width: 60,
        // height: 60,
        opacity: 0,
        // borderColor: "#ff0000"
      });

      TweenMax.to(this.innerCursor, 0.6, {
        backgroundColor: '#C17854',
        borderColor: 'transparent',
        opacity: .2
      });
    };

    const handleMouseLeave = () => {
      this.isStuck = false;
      TweenMax.to(this.outerCursor, 0.6, {
        width: this.outerCursorOriginals.width,
        height: this.outerCursorOriginals.height,
        opacity: 0.2,
        borderColor: "#D6D1CA",
      });

      TweenMax.to(this.innerCursor, 0.6, {
        backgroundColor: 'transparent',
        borderColor: '#C17854',
        opacity: 1
      });
    };

    const linkItems = document.querySelectorAll(".menu-item a");
    linkItems.forEach(item => {
      item.addEventListener("mouseenter", handleMouseEnter);
      item.addEventListener("mouseleave", handleMouseLeave);
    });


    /* Hover su strong titoli */

    // const mainNavHoverTween = TweenMax.to(this.outerCursor, 0.3, {
    //   backgroundColor: "#D6D1CA",
    //   ease: this.easing,
    //   paused: true
    // });

    // const mainNavMouseEnter = () => {
    //   this.outerCursorSpeed = 0;
    //   TweenMax.set(this.innerCursor, { opacity: 0, width: 20, height: 20});
    //   mainNavHoverTween.play();
    // };

    // const mainNavMouseLeave = () => {
    //   this.outerCursorSpeed = 0.2;
    //   TweenMax.set(this.innerCursor, { opacity: 1, width: 30, height: 30, backgroundColor: 'transparent' });
    //   mainNavHoverTween.reverse();
    // };

    // const mainNavLinks = document.querySelectorAll(".homeBlock__title strong");
    // mainNavLinks.forEach(item => {
    //   item.addEventListener("mouseenter", mainNavMouseEnter);
    //   item.addEventListener("mouseleave", mainNavMouseLeave);
    // });


    const mainNavHoverTween = TweenMax.to(this.outerCursor, 0.3, {
      // backgroundColor: "#D6D1CA",
      ease: this.easing,
      paused: true
    });

    const mainNavMouseEnter = () => {
      this.outerCursorSpeed = 0;
      TweenMax.to(this.outerCursor, .3 ,{ scale: 0});
      TweenMax.to(this.innerCursor, .1 ,{ opacity: 0, ease: this.easing,});
      mainNavHoverTween.play();
    };

    const mainNavMouseLeave = () => {
      this.outerCursorSpeed = 0.2;
      TweenMax.to(this.outerCursor, .6 ,{ scale: 1, ease: this.easing,}, "+=1");
      TweenMax.to(this.innerCursor, .6 ,{ opacity: 1, backgroundColor: 'transparent', ease: this.easing }, "+=1");
      mainNavHoverTween.reverse();
    };

    const mainNavLinks = document.querySelectorAll(".homeBlock__button");
    mainNavLinks.forEach(item => {
      item.addEventListener("mouseenter", mainNavMouseEnter);
      item.addEventListener("mouseleave", mainNavMouseLeave);
    });

  }
}

export default mouseInit;
